import React, { useState, Fragment, useCallback, useEffect } from "react";
import Form from "@rjsf/core";
import validator from "@rjsf/validator-ajv8";
import { format } from "date-fns";
import InputWithTooltip from "../../components/InputWithTooltip";
import Button from "../../components/button";
import PageHead from "../../components/pageHead";
import DateInput from "../../components/dateInput";
import AddTrackDayModal from "../../components/addTrackDayModal";
import EditIcon from "../../icons/editIcon";
import TrashIcon from "../../icons/trashIcon";
import AddIcon from "../../icons/addIcon";
import Table from "../../components/table";
import TruckDayCard from "../../components/truckDayCard";
import Pagination from "../../components/pagination";
import MobileNav from "../../components/mobileNav";
import LoadingButton from "../../components/loadingButton";
import DeleteCarModal from "../../components/deleteModal";
import CardSkeleton from "../../components/cardSkeleton";
import NoData from "../../components/noData";
import useMediaQuery from "../../hooks/useMediaQuery";
import TutorialTrackDaysImage from "../../assets/images/tutorialTrackDays.png";
// import { checkScrollDirection } from "../../utils/menuNav";
import { useAxiosPrivate } from "../../hooks/useAxiosPrivate";
import { useAuth } from "../../hooks/useAuth";
import styles from "./style.module.css";
import stylesTable from "../../components/table/style.module.css";
import formStyles from "../../components/form/style.module.css";

const TrackDays = () => {
  const isTablet = useMediaQuery("(max-width: 992px)");
  const isMobile = useMediaQuery("(max-width: 768px)");
  const axiosPrivate = useAxiosPrivate();
  const { auth } = useAuth();

  let monitorBy =
    auth?.monitorBy?.charAt(0).toUpperCase() + auth?.monitorBy?.slice(1);

  if (monitorBy === "Days") {
    monitorBy = "Days";
  } else if (monitorBy === "Sessions") {
    monitorBy = "Sessions";
  } else if (monitorBy === "Laps") {
    monitorBy = "Miles";
  }
  const schema = {
    type: "object",
    required: ["date", "name", "count"],
    properties: {
      date: {
        title: "Date",
        type: "string",
      },
      name: {
        title: "Track Name",
        type: "string",
      },
      count: {
        title: `# of ${monitorBy}`,
        type: "number",
      },
    },
  };

  const uiSchema = {
    "ui:classNames": formStyles.formInner_p0,
    "ui:rootFieldId": "add_track_day",
    date: {
      "ui:widget": DateInput,
      "ui:classNames": `${formStyles.form_field} ${formStyles.col_auto}`,
      "ui:placeholder": "Enter Date",
    },
    name: {
      "ui:classNames": `${formStyles.form_field} ${formStyles.col_auto}`,
      "ui:placeholder": "Enter Track Name",
    },
    count: {
      "ui:widget": InputWithTooltip,
      "ui:classNames": `${formStyles.form_field} ${formStyles.col_auto}`,
      "ui:placeholder": `Enter # of ${monitorBy}`,
      "ui:options": {
        label: false,
        type: "number",
        tooltipText: (
          <Fragment>
            Note: this field accepts decimals, e.g., if you only run in half the
            sessions on <strong>Day 2</strong>, you can enter{" "}
            <strong>1.5 days</strong>, and DashBook will adjust wear
            calculations accordingly.
          </Fragment>
        ),
        position: ["right"],
        transform: { top: -15, left: 1 },
        minimum: 1,
      },
    },

    "ui:submitButtonOptions": {
      props: {
        className: formStyles.form_btn,
      },
      submitText: "Add",
    },
  };

  const widgets = {
    date: DateInput,
  };

  const [isScrolling] = useState(false);
  const [formData, setFormData] = useState({});
  const [trackData, setTrackData] = useState({});
  const [openTrackDayDialog, setOpenTrackDayDialog] = useState(false);
  const [mainColumns, setMainColumns] = useState({
    columns: [
      {
        name: "date",
        title: "Date",
        width: 150,
        sorting: true,
        direction: "",
      },
      {
        name: "name",
        title: "Track Name",
        width: 150,
        sorting: true,
        direction: "",
      },
      {
        name: "count",
        title: `# of ${monitorBy}`,
        width: 180,
        sorting: true,
        direction: "",
      },
      {
        name: "action",
        title: "Action",
        width: "auto",
        sorting: false,
        direction: "",
      },
    ],
  });
  const [rowData, setRowData] = useState([]);
  const [modalTitle, setModalTitle] = useState(`Enter New ${monitorBy}`);
  const [buttonTitle, setButtonTitle] = useState("Add");
  const [apiParams] = useState({});
  const [loading, setLoading] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const [selectedPage, setSelectedPage] = useState(1);
  const [limitData] = useState(10);
  const [totalData, setTotalData] = useState(0);
  // const [editID, setEditID] = useState(null);
  const [openDeleteModal, setOpenDeletModal] = useState(false);

  const handleSorting = (name, index) => {
    let prm = apiParams;
    let tempCol = mainColumns.columns;
    if (tempCol[index].direction === "") {
      tempCol.map((column) =>
        column.name === name
          ? (column.direction = "ASC")
          : (column.direction = "")
      );
      prm.sort_by = name;
      prm.order = 1;
      prm.page = 1;
    } else if (tempCol[index].direction === "ASC") {
      tempCol.map((column) =>
        column.name === name
          ? (column.direction = "DSC")
          : (column.direction = "")
      );
      prm.sort_by = name;
      prm.order = -1;
      prm.page = 1;
    } else if (tempCol[index].direction === "DSC") {
      tempCol.map((column) => (column.direction = ""));
      prm.page = 1;
      delete prm.sort_by;
      delete prm.order;
    }
    setMainColumns({ columns: tempCol });
    setSelectedPage(1);
    fetchTrackDays(apiParams);
  };

  const handlePaginate = (value) => {
    let prm = apiParams;
    prm.page = value;
    setSelectedPage(value);
    setLoading(true);
    fetchTrackDays(prm);
  };

  const onFormSubmit = (formData) => {
    setFormData(formData);
    handleAddTrackDay(formData);
    // if (editID) {
    //   // handleUpdateTrackDay(formData);
    // } else {
    //   handleAddTrackDay(formData);
    // }
  };

  const handleOpenDeleteModal = (item) => {
    setOpenDeletModal(true);
    setTrackData(item);
  };

  const handleCloseDeleteModal = () => {
    setOpenDeletModal(false);
    setTrackData({});
  };

  const handleOpenTrackDayDialog = () => {
    setOpenTrackDayDialog(true);
  };

  const handleCloseTrackDayDialog = (changePage = false) => {
    setOpenTrackDayDialog(false);
    if (changePage) {
      fetchTrackDays(apiParams);
    }
  };

  const handleEditTrackDay = (item) => {
    let date = format(new Date(item.date.replace("Z", "")), "yyyy-MM-dd");
    // setFormData({
    //   date: date,
    //   name: item.name,
    //   count: item.count,
    // });
    setTrackData({
      date: date,
      name: item.name,
      count: item.count,
      _id: item._id,
    });
    // setEditID(item._id);
    setOpenTrackDayDialog(true);
    setModalTitle(`Edit ${monitorBy}`);
    setButtonTitle("Save");
  };

  const fetchTrackDays = useCallback(async (params) => {
    setLoading(true);
    try {
      let urlParams = "";
      if (params) {
        Object.keys(params).forEach(function (key, index) {
          urlParams += (index === 0 ? "?" : "&") + key + "=" + params[key];
        });
      }
      let url = `tracks${urlParams}`;
      let options = {
        method: "GET",
        url,
      };
      await axiosPrivate(options)
        .then((response) => {
          if (response.data.status === 1) {
            setRowData(response.data.tracks);
            setTotalData(response.data.total);
            setLoading(false);
          } else {
            setRowData([]);
            setTotalData(0);
            setLoading(false);
          }
        })
        .catch((err) => {
          if (err.response) {
            setLoading(false);
            // console.error('err.res', err.response.data);
          }
        });
    } catch (error) {
      setLoading(false);
      // console.error('error', error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAddTrackDay = useCallback(
    async (data) => {
      setSaveLoading(true);
      try {
        let url = `tracks/add`;
        let options = {
          method: "POST",
          url,
          data,
        };
        await axiosPrivate(options)
          .then((response) => {
            if (response.data.status === 1) {
              setFormData({});
              fetchTrackDays(apiParams);
            } else {
              setFormData({});
            }
            setSaveLoading(false);
          })
          .catch((err) => {
            if (err.response) {
              setFormData({});
              setSaveLoading(false);
            }
          });
      } catch (error) {
        setFormData({});
        // console.error('error', error);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [apiParams]
  );

  // const handleUpdateTrackDay = useCallback(
  //   async (data) => {
  //     try {
  //       let url = `tracks/${editID}`;
  //       let options = {
  //         method: "PUT",
  //         url,
  //         data,
  //       };
  //       await axiosPrivate(options)
  //         .then((response) => {
  //           if (response.data.status === 1) {
  //             fetchTrackDays(apiParams);
  //             setFormData({});
  //             setEditID(null);
  //             setModalTitle(`Enter New ${monitorBy}`);
  //             setButtonTitle("Add");
  //           } else {
  //             setFormData({});
  //             setModalTitle(`Enter New ${monitorBy}`);
  //             setButtonTitle("Add");
  //             // console.error('err.res', response);
  //           }
  //         })
  //         .catch((err) => {
  //           if (err.response) {
  //             setFormData({});
  //           }
  //         });
  //     } catch (error) {
  //       // console.error('error', error);
  //     }
  //   }, // eslint-disable-next-line react-hooks/exhaustive-deps
  //   [editID]
  // );

  const handleDeleteService = async () => {
    const response = await axiosPrivate.delete(`/tracks/${trackData._id}`);
    if (response.data.status === 1) {
      let prm = apiParams;
      prm.page = 1;
      setSelectedPage(1);
      fetchTrackDays(prm);
      handleCloseDeleteModal();
    }
  };

  const handleScroll = (e) => {
    // const scrollDirection = checkScrollDirection(e);
    // setIsScrolling(scrollDirection);
  };

  function generateRows(tempArray) {
    const tempRowArray = [];
    if (tempArray) {
      tempArray.map((item) =>
        tempRowArray.push({
          date: (
            <div className={stylesTable.table_cell_text}>
              {format(new Date(item.date.replace("Z", "")), "MMMM dd, yyyy")}
            </div>
          ),
          name: <div className={stylesTable.table_cell_text}>{item.name}</div>,
          count: (
            <div className={stylesTable.table_cell_text}>{item.count}</div>
          ),
          action: (
            <div className={stylesTable.table_action}>
              <button type="button" onClick={() => handleEditTrackDay(item)}>
                <EditIcon />
              </button>
              <button type="button" onClick={() => handleOpenDeleteModal(item)}>
                <TrashIcon />
              </button>
            </div>
          ),
        })
      );
    }
    return tempRowArray;
  }

  useEffect(() => {
    fetchTrackDays(apiParams);
  }, [fetchTrackDays, apiParams]);

  return (
    <Fragment>
      <PageHead
        logo={isMobile}
        title={"Track " + monitorBy}
        tutorialContent={
          <Fragment>
            <p>
              Use this section to log your time on the track. Enter details such
              as the <strong>event name, date, and duration</strong>. Based on
              your consumable tracking settings (Days/Sessions/Miles), you’ll be
              prompted to enter corresponding data.
            </p>
            <p>For example:</p>
            <ul>
              <li>
                <em>Sebring PCA Event, Jan 1, 2025, 2 track days.</em>
              </li>
            </ul>
            <img src={TutorialTrackDaysImage} alt={"Entering Track Days"} />
            <p>
              <strong>
                Enter as many previous events as you need to provide the usage
                of all your Consumable items
              </strong>
              . For long-life parts like brake rotors, that may require quite a
              few track days to get a complete usage history. If you don’t
              recall all the track days, that’s OK, you can enter more later.
              Just remember - DashBook won’t be able to provide an accurate
              status of any items that don’t include all the track events in
              their history.
            </p>
            <p>
              <strong>Tip #1</strong>: The # of Days field accepts decimals, so
              if you only complete half the sessions on <strong>Day 2</strong>,
              you can enter <strong>1.5 days</strong>, and DashBook will adjust
              wear calculations accordingly.
            </p>
            <p>
              <strong>Tip #2</strong>: You can also add track days at the top of
              the <strong>Track History Page</strong>.
            </p>
          </Fragment>
        }
      />
      <div className={styles.body}>
        {isTablet ? (
          <div className={styles.body_head}>
            <div className={styles.body_head_inner}>
              <div className={styles.filters}></div>
              <div className={styles.add_btn}>
                <Button
                  title={"Track " + monitorBy}
                  buttonType="outlined"
                  buttonColor="primary"
                  startIcon={<AddIcon />}
                  onClick={handleOpenTrackDayDialog}
                />
              </div>
            </div>
          </div>
        ) : (
          <Fragment>
            <div className={styles.body_title}>{modalTitle}</div>
            <div className={styles.add_form}>
              <Form
                className={`${formStyles.form} ${formStyles.form_inline}`}
                schema={schema}
                uiSchema={uiSchema}
                widgets={widgets}
                formData={formData}
                validator={validator}
                showErrorList={false}
                omitExtraData={true}
                liveValidate={false}
                onSubmit={({ formData }) => {
                  onFormSubmit(formData);
                }}
              >
                <div className={styles.form_actions}>
                  <LoadingButton
                    type="submit"
                    loading={saveLoading}
                    title={"Add"}
                  />
                </div>
              </Form>
            </div>
            <div className={styles.body_title}>{monitorBy} History</div>
          </Fragment>
        )}
        <div className={styles.body_view} onScroll={handleScroll}>
          {isMobile ? (
            <Fragment>
              {rowData.map((item, index) => (
                <TruckDayCard
                  key={index}
                  item={item}
                  handleEdit={handleEditTrackDay}
                  handelDelete={handleOpenDeleteModal}
                />
              ))}
              {loading && <CardSkeleton />}
              {totalData === 0 && !loading && <NoData />}
            </Fragment>
          ) : (
            <Table
              rows={generateRows(rowData)}
              columns={mainColumns.columns}
              selectedPage={selectedPage}
              handlePagination={handlePaginate}
              loading={loading}
              handleSort={handleSorting}
              limitData={10}
              totalData={totalData}
            />
          )}
        </div>
        {isMobile && (
          <Fragment>
            {totalData > limitData && (
              <div className={styles.body_foot}>
                <Pagination
                  totalPages={totalData}
                  limitData={limitData}
                  selectedPage={selectedPage}
                  handlePagination={handlePaginate}
                />
              </div>
            )}
          </Fragment>
        )}
      </div>
      <AddTrackDayModal
        open={openTrackDayDialog}
        onClose={handleCloseTrackDayDialog}
        trackData={trackData}
        title={modalTitle}
        buttonTitle={buttonTitle}
      />
      {isMobile && (
        <Fragment>
          <MobileNav defaultActive={true} isScrolling={isScrolling} />
        </Fragment>
      )}
      <DeleteCarModal
        open={openDeleteModal}
        onClose={handleCloseDeleteModal}
        title={`Deleting ${monitorBy}`}
        description="Are you sure you want to delete this record? This process cannot be undone."
        onDelete={handleDeleteService}
      />
    </Fragment>
  );
};

export default TrackDays;
